function initCartUpsellSwiper() {
  document.getElementById('cstm-cart-upsell-block').style.display = 'block';
  cartUpsellSwiper = new Swiper('.cstm-cart-upsell-swiper', {
    slidesPerView: 2.4,
    spaceBetween: 20,
  
    breakpoints: {
      1000: {
        slidesPerView: 3,
      },
    },
  
    navigation: {
      nextEl: '.cstm-cart-upsell-swiper-button-next',
      prevEl: '.cstm-cart-upsell-swiper-button-prev',
    },
  });
}